import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clinics from "./pages/Clinics";
import ClinicDetail from "./pages/ClinicDetail";
import Pipeline from "./pages/Pipeline";
import Commissions from "./pages/Commissions";
import Reports from "./pages/Reports";
import AuditLogs from "./pages/AuditLogs";
import Reminders from "./pages/Reminders";
import Calendar from "./pages/Calendar";
import TodaysPlan from "./pages/TodaysPlan";
import UsersAdmin from "./pages/UsersAdmin";
import {
  Contacts, Products, Meetings, Mileage, Expenses, Devices, Workshops, Tasks, Documents,
} from "./pages/modules";

function Page({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Page><Dashboard /></Page>} />
          <Route path="/todays-plan" element={<Page><TodaysPlan /></Page>} />
          <Route path="/clinics" element={<Page><Clinics /></Page>} />
          <Route path="/clinics/:id" element={<Page><ClinicDetail /></Page>} />
          <Route path="/contacts" element={<Page><Contacts /></Page>} />
          <Route path="/pipeline" element={<Page><Pipeline /></Page>} />
          <Route path="/products" element={<Page><Products /></Page>} />
          <Route path="/meetings" element={<Page><Meetings /></Page>} />
          <Route path="/calendar" element={<Page><Calendar /></Page>} />
          <Route path="/mileage" element={<Page><Mileage /></Page>} />
          <Route path="/expenses" element={<Page><Expenses /></Page>} />
          <Route path="/commissions" element={<Page><Commissions /></Page>} />
          <Route path="/devices" element={<Page><Devices /></Page>} />
          <Route path="/workshops" element={<Page><Workshops /></Page>} />
          <Route path="/tasks" element={<Page><Tasks /></Page>} />
          <Route path="/reminders" element={<Page><Reminders /></Page>} />
          <Route path="/documents" element={<Page><Documents /></Page>} />
          <Route path="/reports" element={<Page roles={["admin", "director", "finance"]}><Reports /></Page>} />
          <Route path="/users" element={<Page roles={["admin"]}><UsersAdmin /></Page>} />
          <Route path="/audit" element={<Page roles={["admin", "director", "finance"]}><AuditLogs /></Page>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
